import { render, staticRenderFns } from "./Belge.vue?vue&type=template&id=34663e2c&scoped=true&"
import script from "./Belge.vue?vue&type=script&lang=js&"
export * from "./Belge.vue?vue&type=script&lang=js&"
import style0 from "./Belge.vue?vue&type=style&index=0&id=34663e2c&lang=scss&scoped=true&"
import style1 from "./Belge.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34663e2c",
  null
  
)

export default component.exports